import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Trash2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const input = "w-full px-4 py-3 rounded-xl border border-stone-border focus:outline-none focus:ring-2 focus:ring-brand bg-white";
const CONTACT = "restaurantejobs.official@gmail.com";

// Public page so users can request account/data deletion WITHOUT logging in (Play Store requirement).
export default function DataDeletion() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ email: "", reason: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/deletion-requests", { email: form.email.trim(), reason: form.reason.trim() });
      setDone(true);
    } catch (err) {
      if (err?.response?.status === 404 || err?.response?.status === 405) {
        toast.error(t("dataDeletion.notDeployed", { email: CONTACT }));
      } else {
        toast.error(t("common.error"));
      }
    } finally { setSending(false); }
  };

  if (done) {
    return (
      <div className="max-w-xl mx-auto px-4 sm:px-6 py-16 text-center" data-testid="data-deletion-done">
        <div className="w-14 h-14 rounded-full bg-housing/15 flex items-center justify-center mx-auto mb-4"><CheckCircle2 className="w-7 h-7 text-housing" /></div>
        <h1 className="font-heading text-2xl font-bold text-stone-text mb-2">{t("dataDeletion.doneTitle")}</h1>
        <p className="text-stone-sub">{t("dataDeletion.doneBody")}</p>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-12" data-testid="data-deletion-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-red-50 flex items-center justify-center"><Trash2 className="w-6 h-6 text-red-600" /></div>
        <h1 className="font-heading text-3xl font-bold text-stone-text">{t("dataDeletion.title")}</h1>
      </div>
      <p className="text-stone-sub mb-6">{t("dataDeletion.subtitle")}</p>
      <form onSubmit={submit} className="space-y-4 bg-white border border-stone-border rounded-2xl p-6" data-testid="data-deletion-form">
        <div>
          <label className="block text-sm font-medium text-stone-sub mb-1">{t("dataDeletion.email")}</label>
          <input data-testid="deletion-email" type="email" required className={input} value={form.email} onChange={set("email")} placeholder="tu@correo.com" />
        </div>
        <div>
          <label className="block text-sm font-medium text-stone-sub mb-1">{t("dataDeletion.reason")}</label>
          <textarea data-testid="deletion-reason" rows={4} className={input} value={form.reason} onChange={set("reason")} />
        </div>
        <button data-testid="deletion-submit" type="submit" disabled={sending} className="w-full py-3 rounded-xl bg-red-600 text-white font-semibold hover:bg-red-700 transition-colors disabled:opacity-60">
          {sending ? "..." : t("dataDeletion.submit")}
        </button>
        <p className="text-xs text-stone-muted text-center">{t("dataDeletion.note", { email: CONTACT })}</p>
      </form>
    </div>
  );
}
